import _ from 'lodash'
import qs from 'qs'

export default class MatchAPI {

  apiKey
  clientId
  userId

  constructor(apiKey, clientId, userId) {
    this.apiKey = apiKey
    this.clientId = clientId
    this.userId = userId
    this.geocode = this.geocode.bind(this)
    this.lookup = this.lookup.bind(this)
  }

  async geocode(environment, locationType, query, opts) {
    const params = { ...{ query }, ...opts }
    const resp = await fetch(`${environment.url}/match/v1/${locationType}/geocode?${qs.stringify(_.pickBy(params))}`, {
      headers: { 'x-api-key': this.apiKey, 'x-client-id': this.clientId, 'x-user-id': this.userId }
    })
    return resp.json()
  }

  async lookup(environment, locationType, id) {
    const resp = await fetch(`${environment.url}/match/v1/${locationType}/lookup/byId/${id}`, {
      headers: { 'x-api-key': this.apiKey, 'x-client-id': this.clientId, 'x-user-id': this.userId }
    })
    return resp.json()
  }

}
